import React from 'react';
import Grid from '@mui/material/Grid2';

import './ImageGrid.css';
import { Link } from 'react-router-dom';

export interface ImageGridProps {
    data: { image: string, title?: string, onClick?: () => void, to?: string }[];
}

const ImageGrid: React.FC<ImageGridProps> = ({ data }) => {
    return (
        <div className='data-grid-container'>
            <Grid container spacing={4} className='data-grid' >
                {data.map((item, index) => (
                    <Grid item xs={12} sm={3} md={3} lg={3} key={index}>
                        {
                            item.to ? (
                                <Link to={item.to} className='data-link'>
                                    <div className='data-card' onClick={item.onClick}>
                                        <img className='data-img' src={item.image} alt={item.title} />
                                        <h5>{item.title}</h5>
                                    </div>
                                </Link>
                            ) : (
                                <div className='data-card' onClick={item.onClick}>
                                    <img className='data-img' src={item.image} alt={item.title} />
                                    <h5>{item.title}</h5>
                                </div>
                            )
                        }
                    </Grid>
                ))}
            </Grid>
        </div>
    );
};

export default ImageGrid;
